import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as moment from 'moment';

interface State {
    response: any;
    errorMessage: string;
}

export class Diagnostic extends React.Component<RouteComponentProps<any>, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            response: {},
            errorMessage: ""
        };

        this.handleForceGC = this.handleForceGC.bind(this);
        this.handleClearCache = this.handleClearCache.bind(this);
    }

    componentDidMount() {
        this.executeAPI();
    }

    private handleForceGC() {
        fetch('api/diagnostic/ForceGC')
            .then(response => response.json() as Promise<any>)
            .then(data => {
                this.setState({
                    response: data,
                });
            }).catch(err => {
                this.setState({
                    errorMessage: "Something went wrong"
                });
            });
    }

    private handleClearCache() {
        fetch('api/diagnostic/ClearCache')
            .then(response => response.json() as Promise<any>)
            .then(data => {
                this.setState({
                    response: data,
                });
            }).catch(err => {
                this.setState({
                    errorMessage: "Something went wrong"
                });
            });
    }

    private executeAPI() {
        fetch('api/diagnostic/getdiagnostic')
            .then(response => response.json() as Promise<any>)
            .then(data => {
                this.setState({
                    response: data,
                });
            }).catch(err => {
                this.setState({
                    errorMessage: "Something went wrong"
                });
            });
    }

    public render() {
        return <div>
            <div className="page-header">
                <h3 className="page-header-text">Usage Details</h3>
            </div>
            <div>
                {this.state.errorMessage ? <h5> {this.state.errorMessage} </h5> : <div>
                    <table className="table table-bordered table-striped">
                        <tbody>
                            <tr>
                                <td>Current Time</td>
                                <td> {moment(this.state.response.CurrentTime).format('YYYY-MM-DD, HH:mm:ss [GMT]Z')} </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Process ID</td>
                                <td> {this.state.response.PID} </td>
                                <td>Engine Process Id</td>
                            </tr>
                            <tr>
                                <td>Allocated Memory</td>
                                <td> {this.state.response.Allocated} </td>
                                <td>The memory occupied by objects.</td>
                            </tr>
                            <tr>
                                <td>Working Set</td>
                                <td> {this.state.response.WorkingSet} </td>
                                <td>The physical memory (in MB) allocated to process.</td>
                            </tr>
                            <tr>
                                <td>Peak Working Set</td>
                                <td> {this.state.response.PeakWorkingSet64} </td>
                                <td>The peak physical memory usage</td>
                            </tr>
                            <tr>
                                <td>Private Bytes</td>
                                <td> {this.state.response.PrivateMemory} </td>
                                <td>The memory (in MB) allocated to process.</td>
                            </tr>
                            <tr>
                                <td>Virtual Memory</td>
                                <td> {this.state.response.VirtualMemorySize64} </td>
                                <td>The virtual memory allocated</td>
                            </tr>
                            <tr>
                                <td>Peak Virtual Memory</td>
                                <td> {this.state.response.PeakVirtualMemorySize64} </td>
                                <td>The peak virtual memory usage</td>
                            </tr>
                            <tr>
                                <td>Paged System Memory</td>
                                <td> {this.state.response.PagedSystemMemorySize64} </td>
                                <td>The pageable system memory</td>
                            </tr>
                            <tr>
                                <td>Peak Paged Memory Size</td>
                                <td> {this.state.response.PeakPagedMemorySize64} </td>
                                <td>The peak pageable system memory</td>
                            </tr>
                            <tr>
                                <td>Cached Objects In Memory</td>
                                <td> {this.state.response.CachedObjectsInMemory} </td>
                                <td>Total cached objects in Memory</td>
                            </tr>
                        </tbody>
                    </table>
                    <hr />
                    <div className="engine-row">
                        <div className="pull-left">
                            <button type="button" className="btn btn-primary" onClick={this.handleForceGC}>Force GC</button>&nbsp; &nbsp;
                                        <button type="button" className="btn btn-primary" onClick={this.handleClearCache}>Clear Cache</button>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    }


}


// WEBPACK FOOTER //
// ./ClientApp/components/Diagnostic.tsx